<script>
import ArchivesUsers from "./mixins/archives-users";
import toasts from "../../mixins/toasts";
import RoleList from "../../users/RoleList";

export default Vue.extend({
  props: ["user"],
  mixins: [ArchivesUsers, toasts],
  components: { RoleList },
  methods: {
    submit: function() {},
    resetPassword() {
      this.$dialog.confirm({
        title: "Сброс пароля",
        message:
          `Вы собираетесь сбросить текущий пароль.<br>` +
          `Для данного пользователя будет установлен одноразовый пароль, ` +
          `который будет показан <b>один раз</b>.`,
        confirmText: "Сбросить",
        cancelText: "Отмена",
        type: "is-warning",
        hasIcon: true,
        onConfirm: () => {
          this.loading = true;
          let loading = this.$loading.open();

          axios
            .delete(`/api/users/${this.user.id}/security/password`)
            .then(response => {
              this.loading = false;
              loading.close();

              this.$dialog.alert({
                title: "Пароль сброшен",
                message:
                  `Пароль был успешно сброшен.<br>` +
                  `Новый одноразовый пароль: <b>${
                    response.data.password
                  }</b><br>` +
                  `Текущий логин: <b>${response.data.login}</b>`,
                confirmText: "Ок",
                type: "is-success",
                hasIcon: true
              });
            })
            .catch(error => {
              switch (error.response.status) {
                default: {
                  this.toast("error", "@unexpected", error);
                  break;
                }
              }

              this.loading = false;
              loading.close();
            });
        }
      });
    },
    remove: function() {
      this.$dialog.confirm({
        title: "Удаление пользователя",
        message:
          `Вы уверены, что хотите удалить пользователя ` +
          `<b>${this.user.full_name}</b>?`,
        confirmText: "Удалить пользователя",
        cancelText: "Отмена",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          let loading = this.$loading.open();

          axios
            .delete(`/api/users/${this.user.id}`)
            .then(response => {
              this.toast("success", "Пользователь был успешно удалён");
              _.delay(() => {
                window.open("/users", "_self");
              }, 2000);
            })
            .catch(error => {
              this.toast("error", "@unexpected", error);
              loading.close();
            });
        }
      });
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/views/users/Show.vue